import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { attendanceTypeData } from "../../../../data";
import moment from "moment";
import { save } from "../../../../features/save/saveSlice";

const { TextArea } = Input;

const AddDetailsModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { attendanceHeaderObj } = useSelector((state) => state.folder);
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }
  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.attdType) {
      toast.error("Select attendance type");
      return;
    }
    const res = await dispatch(
      save({
        attdId: prodd?.attdId ? prodd?.attdId : null,

        attdType: formData?.attdType,
        attdDesc: formData?.attdDesc,
        attdPpId: attendanceHeaderObj?.attPpId,
        attdAttId: attendanceHeaderObj?.attId,
        // attdLat: formData?.attdLat,
        // attdLong: formData?.attdLong,
        attdClockedTime: formData?.attdClockedTime
          ? dayjs(formData.attdClockedTime).format("YYYY-MM-DD HH:mm:ss")
          : null,
        attdClockedDate: attendanceHeaderObj?.attDate,

        url: "hr/saveAttendanceDetail.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await setFormData({});
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title="Add attendance details"
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5">
            <Form.Item
              className=""
              label={<span>Attendance Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select attendance type",
                },
              ]}
            >
              <Select
                name="attdType"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  attendanceTypeData?.length > 0 &&
                  attendanceTypeData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "attdType");
                }}
                value={formData?.attdType}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
              />
            </Form.Item> 
            {/* <Form.Item
              label="Latitude"
              rules={[
                {
                  required: false,
                  message: "Enter latitude",
                },
              ]}
            >
              <InputNumber
                name="attdLat"
                value={formData?.attdLat}
                min={0}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                onChange={(value) => onChangeOther(value, "attdLat")}
                className="input flex"
              />
            </Form.Item>
            <Form.Item
              label="Longitude"
              rules={[
                {
                  required: false,
                  message: "Enter Longitude",
                },
              ]}
            >
              <InputNumber
                name="attdLong"
                value={formData?.attdLong}
                min={0}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                onChange={(value) => onChangeOther(value, "attdLong")}
                className="input flex"
              />
            </Form.Item> */}

            <Form.Item
              rules={[
                {
                  required: false,
                  message: "Clock time field is required",
                },
              ]}
              label="Clock time"
            >
              <DatePicker
                name="attdClockedTime"
                className="input"
                placeholder={
                  formData?.attdClockedTime
                    ? moment(formData.attdClockedTime)?.format(
                        "YYYY-MM-DD HH:mm"
                      )
                    : "Select Date"
                }
                value={
                  formData?.attdClockedTime
                    ? dayjs(formData.attdClockedTime)
                    : null
                }
                format="YYYY-MM-DD HH:mm"
                showTime={{
                  format: "HH:mm",
                  defaultValue: dayjs("00:00", "HH:mm"),
                }}
                onChange={(value) => {
                  onMonthChange(value, "attdClockedTime");
                }}
              />
            </Form.Item> 
          </div>
          <Form.Item
              label="Project Description"
              rules={[
                {
                  required: false,
                  message: "Please add project description",
                },
              ]}
            >
              <TextArea
                rows={4}
                name="attdDesc"
                value={formData?.attdDesc}
                onChange={onChange}
                className="input-textarea"
              />
            </Form.Item>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddDetailsModal;
